/** basic.patrolAll */
export default {
    inspectImg: "Фото проверки",
    hiddenTroubleBtn: "Изменить",
    hiddenTroubleBtnTips: "Удалить тип аномалии?",
    addHiddenTrouble: "Новый тип аномалии",
    editTitle: "Изменить название типа аномалии",
}

